<template>
  <div :class="dark?'boxtitle darkBox':'boxtitle'">
    <div class="titleBox" :id="'part' + index">
      <h1 :class="dark?'font-weight-thin lg-4 second_title white--text':'font-weight-thin lg-4 second_title'" v-show="firstTitle">
        {{firstTitle}}
      </h1>
    </div>
    <div class="contentBox" style="margin-top:3rem;flex-direction:column;justify-content:center;align-items:center">
      <p v-show="desc" :class="dark?'text-justify body_text white--text':'text-justify body_text'" style="line-height:2;margin-bottom:3rem">{{desc}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'box-title',

  props: {
    firstTitle: String,
    desc: String,
    dark: Boolean,
    index: Number
  },
  created () {
    this.$nextTick(() => {
      // console.log(this.data)
    })
  },
  data: () => ({

  })

}
</script>

<style>

</style>
